import React from 'react';

interface Props {
  title: string;
}

// Segnaposto per le sezioni di navigazione non ancora sviluppate (Risky Assets, Whitelists,
// SOAR), per mantenere fin da ora la struttura di navigazione completa prevista dalla roadmap
// (vedi docs/ROADMAP.md). Il testo è quello voluto dall'utente (20/10/2026): al cliente non si
// mostra la fase di sviluppo, lo si rimanda al proprio fornitore del servizio.
export default function ComingSoon({ title }: Props) {
  return (
    <div className="card p-8 text-center">
      <h1 className="text-xl font-semibold text-gray-900 mb-2">{title}</h1>
      <p className="text-gray-500 text-sm">This section is not available, please contact your service provider.</p>
    </div>
  );
}
